//数字のアニメーション
$('.inview-fadein').on('inview', function() {
    $(this).toggleClass('FadeIn');
});

//MORE のトグルボタン
$(function () {
    $('.js-toggle-target').hide();
    $('.js-toggle-open').click(function () {
        $(this).prevAll('.service__step__process__content__point__inn').children('.js-toggle-target').slideToggle();
        $(this).toggleClass('is-active');
    });
});

//input 日付
$(function () {
    flatpickr(".js-datePicker", {
        locale: "ja",
        dateFormat: "Y/m/d",
        disableMobile: true,
    });
});
